import { AxiosPromise, AxiosStatic } from "axios";
import { TUpdateNotificationPayload } from "../types";

const updateNotifications =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (notifications: TUpdateNotificationPayload[]): AxiosPromise<void> =>
    await appAxios.put(`${serverURL}/notifications`, notifications, {
      withCredentials: true,
    });

export default updateNotifications;
